import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls back to the top whenever the route changes.
 * Handles both window-level scroll and AppShell's `.content-area`
 * (which has its own overflow-y in some layouts).
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use rAF so the new route's content has mounted before we measure/scroll.
    const id = requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      const contentArea = document.querySelector(".content-area");
      if (contentArea) contentArea.scrollTop = 0;
    });
    return () => cancelAnimationFrame(id);
  }, [pathname]);

  return null;
}
